import _objectSpread from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import * as THREE from 'three';
function shaderMaterial(uniforms, vertexShader, fragmentShader, onInit) {
  return class extends THREE.ShaderMaterial {
    constructor() {
      const entries = Object.entries(uniforms); // Create unforms and shaders

      super({
        uniforms: entries.reduce((acc, _ref) => {
          let [name, value] = _ref;
          const uniform = THREE.UniformsUtils.clone({
            [name]: {
              value
            }
          });
          return _objectSpread(_objectSpread({}, acc), uniform);
        }, {}),
        vertexShader,
        fragmentShader
      }); // Create getter/setters

      entries.forEach(_ref2 => {
        let [name] = _ref2;
        return Object.defineProperty(this, name, {
          get: () => this.uniforms[name].value,
          set: v => this.uniforms[name].value = v
        });
      });
      if (onInit) onInit(this);
    }
  };
}
export { shaderMaterial };